import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './Title.module.scss';

export const Title = ({
  children,
  customClasses = null,
  className,
  align = 'center',
  variables = {},
}) => {
  const styles = mergeClasses(defaultClasses, customClasses);
  return (
    <div
      className={clsx(
        styles.root,
        styles.title,
        styles[`title_align_${align}`],
        className,
      )}
      style={variables}
    >
      {children}
    </div>
  );
};

Title.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  customClasses: PropTypes.shape({
    root: PropTypes.string,
    title: PropTypes.string,
  }),
  align: PropTypes.string,
  variables: PropTypes.object,
};

export default Title;
